import PropTypes from 'prop-types';
import { Alert, Button, Box } from '@mui/material';
import SafetyCertificateOutlined from '@ant-design/icons/SafetyCertificateOutlined';
import InfoCircleOutlined from '@ant-design/icons/InfoCircleOutlined';
import WarningOutlined from '@ant-design/icons/WarningOutlined';
import CloseCircleOutlined from '@ant-design/icons/CloseCircleOutlined';

export default function VerificationBanner({ user, onOpenModal }) {
  if (!user || user.verification_status === 'verified') {
    return null;
  }

  const status = user.verification_status || 'unverified';

  if (status === 'unverified') {
    return (
      <Box sx={{ mb: 2.5 }}>
        <Alert
          severity="warning"
          icon={<WarningOutlined />}
          action={
            <Button
              color="inherit"
              size="small"
              variant="outlined"
              onClick={onOpenModal}
              startIcon={<SafetyCertificateOutlined />}
              sx={{ fontWeight: 600, borderColor: 'currentColor', whiteSpace: 'nowrap' }}
            >
              Validar Conta Agora
            </Button>
          }
        >
          <strong>Modo de Teste Ativo (Conta Não Validada):</strong> A sua conta opera atualmente em Sandbox. Submeta os seus documentos (Nome Individual ou Empresa) para desbloquear o <strong>Modo de Produção (Live)</strong> e transacionar em tempo real.
        </Alert>
      </Box>
    );
  }

  if (status === 'pending') {
    return (
      <Box sx={{ mb: 2.5 }}>
        <Alert
          severity="info"
          icon={<InfoCircleOutlined />}
          action={
            <Button
              color="inherit"
              size="small"
              onClick={onOpenModal}
              sx={{ fontWeight: 600, textDecoration: 'underline' }}
            >
              Atualizar Documentos
            </Button>
          }
        >
          <strong>Documentos em Análise:</strong> A sua documentação de conformidade foi submetida e está a ser revista pela nossa equipa de validação.
        </Alert>
      </Box>
    );
  }

  if (status === 'rejected') {
    return (
      <Box sx={{ mb: 2.5 }}>
        <Alert
          severity="error"
          icon={<CloseCircleOutlined />}
          action={
            <Button
              color="error"
              size="small"
              variant="contained"
              onClick={onOpenModal}
              sx={{ fontWeight: 600, whiteSpace: 'nowrap' }}
            >
              Corrigir Documentos
            </Button>
          }
        >
          <strong>Validação Recusada:</strong> {user.verification_rejection_reason || 'Os documentos apresentados não puderam ser validados.'}
        </Alert>
      </Box>
    );
  }

  return null;
}

VerificationBanner.propTypes = {
  user: PropTypes.object,
  onOpenModal: PropTypes.func.isRequired
};
